import { useMemo } from 'react';

export const formatCurrency = (value) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value || 0);

/**
 * Centraliza o cálculo do pedido, que antes estava copiado dentro de
 * Pix, CartaoCredito e CreditoPrePago (as três com a mesma conta).
 *
 * Devolve:
 *  - totals: { [nome do item]: valor somado }
 *  - subtotal: total sem desconto (é o que o /comprar espera no campo `total`)
 *  - total: subtotal - desconto (é o que o Pix e o saldo cobram)
 */
export function useCheckoutTotals(items, coupon) {
  return useMemo(() => {
    const lista = Array.isArray(items) ? items : [];

    const totals = lista.reduce((acc, item) => {
      const nome = item.nome;
      acc[nome] = (acc[nome] || 0) + item.quantidade * item.valor;
      return acc;
    }, {});

    const subtotal = Object.values(totals).reduce((acc, valor) => acc + valor, 0);
    const quantidade = lista.reduce((acc, item) => acc + item.quantidade, 0);

    let desconto = 0;
    if (coupon && coupon.isValid) {
      desconto = coupon.is_porcentagem === 1 ? subtotal * (coupon.discount / 100) : coupon.discount;
    }
    // Trava o desconto no subtotal para nunca enviar um valor negativo ao gateway.
    desconto = Math.min(Math.max(desconto, 0), subtotal);

    return {
      totals,
      subtotal,
      quantidade,
      desconto,
      total: subtotal - desconto,
      temDesconto: desconto > 0,
    };
  }, [items, coupon]);
}
